import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  SearchValue: "",
  SelectDate: "",
  SelectAcount: "",
};

export const CustomerSlice = createSlice({
  name: "CustomerSlice",
  initialState,
  reducers: {
    SetSearchValues: (state, action) => {
      state.SearchValue = action.payload;
    },
    SetSelectedDate: (state, action) => {
      state.SelectDate = action.payload;
    },
    SetSelectAcount: (state, action) => {
      state.SelectAcount = action.payload;
    },
  },
});

export const { SetSearchValues, SetSelectedDate, SetSelectAcount } =
  CustomerSlice.actions;
export default CustomerSlice.reducer;
